<div class="gw-space-y-6 gw-p-x-large gw-max-w-3xl">
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <p class="gw-text-text-primary gw-text-base">
      {{
        'features.settings.parameters.feeCollectionPolicy.description'
          | translate
      }}
    </p>
    <div class="gw-space-y-3 gw-mb-4">
      <label class="gw-flex gw-items-center gw-gap-2 gw-cursor-pointer">
        <input
          type="radio"
          formControlName="mode"
          value="simple"
          class="gw-w-4 gw-h-4"
        />
        <span>{{
          'features.settings.parameters.feeCollectionPolicy.modeSimple'
            | translate
        }}</span>
      </label>
      <label class="gw-flex gw-items-center gw-gap-2 gw-cursor-pointer">
        <input
          type="radio"
          formControlName="mode"
          value="advanced"
          class="gw-w-4 gw-h-4"
        />
        <span>{{
          'features.settings.parameters.feeCollectionPolicy.modeAdvanced'
            | translate
        }}</span>
      </label>
    </div>
    <div *ngIf="formGroup.get('mode')?.value === 'simple'" class="gw-max-w-md">
      <gatewee-select-v3
        [items]="simpleItems"
        formControlName="simple"
        [label]="
          'features.settings.parameters.feeCollectionPolicy.simple.label'
            | translate
        "
        inputId="fcp-simple"
        [required]="true"
      ></gatewee-select-v3>
    </div>
    <div *ngIf="formGroup.get('mode')?.value === 'advanced'">
      <label class="gw-text-sm gw-text-text-secondary gw-block gw-mb-2">{{
        'features.settings.parameters.feeCollectionPolicy.advancedLabel'
          | translate
      }}</label>
      <textarea
        formControlName="advancedJson"
        rows="14"
        class="gw-w-full gw-font-mono gw-text-sm gw-p-3 gw-rounded-md gw-border gw-border-border-normal gw-bg-background-elevation-1"
        spellcheck="false"
      ></textarea>
    </div>
    <div class="gw-flex gw-justify-end gw-gap-3 gw-mt-6">
      <gatewee-button
        variant="outline"
        [title]="'common.actions.cancel' | translate"
        (clicked)="close()"
        [disabled]="submitting"
      ></gatewee-button>
      <gatewee-button
        variant="primary"
        [title]="'common.actions.save' | translate"
        type="submit"
        [disabled]="submitting || formGroup.invalid"
      ></gatewee-button>
    </div>
  </form>
</div>
